<template>
  <StatistichePDC />
</template>

<script>
import StatistichePDC from '../../components/pratiche/gestione-pdc/statistiche/StatistichePDC.vue'

export default {
  components: {
    StatistichePDC
  },
  mounted() {
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  }
}
</script>
